var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5278 13.8641L12.5734 10.1239C13.4726 8.86123 13.9163 7.28359 13.6788 5.60252C13.2738 2.74313 10.7961 0.416195 7.76999 0.0538272C3.27084 -0.484647 -0.512424 3.09372 0.0569156 7.3492C0.440131 10.2126 2.90064 12.558 5.92408 12.9392C7.70141 13.1639 9.36972 12.7444 10.7044 11.8937L14.6588 15.6339C15.1748 16.122 16.0116 16.122 16.5276 15.6339C17.0431 15.1452 17.0431 14.3516 16.5278 13.8641ZM2.6131 6.4993C2.6131 4.29391 4.51001 2.49972 6.84168 2.49972C9.17335 2.49972 11.0703 4.29391 11.0703 6.4993C11.0703 8.70469 9.17335 10.4989 6.84168 10.4989C4.51001 10.4989 2.6131 8.70531 2.6131 6.4993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseSearch);
export default __webpack_public_path__ + "static/media/purchase-search.cf1840ca0b7c33489c6caf4b5e006de7.svg";
export { ForwardRef as ReactComponent };